import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M21.2812 16.8C20.6109 16.8 20.0625 16.26 20.0625 15.6V9.6C20.0625 5.34 17.1741 2.97602 13.9688 2.49602V1.2C13.9688 0.54 13.4203 0 12.75 0C12.0797 0 11.5312 0.54 11.5312 1.2V2.49602C8.32594 2.97602 5.4375 5.34 5.4375 9.6V15.6C5.4375 16.26 4.88906 16.8 4.21875 16.8C3.54844 16.8 3 17.34 3 18C3 18.66 3.54844 19.2 4.21875 19.2H9.09375V20.4C9.09375 22.392 10.7269 24 12.75 24C14.7731 24 16.4062 22.392 16.4062 20.4V19.2H21.2812C21.9516 19.2 22.5 18.66 22.5 18C22.5 17.34 21.9516 16.8 21.2812 16.8ZM13.9688 20.4C13.9688 21.06 13.4203 21.6 12.75 21.6C12.0797 21.6 11.5312 21.06 11.5312 20.4V19.2H13.9688V20.4ZM17.625 16.8H7.875V9.6C7.875 6.396 10.3125 4.8 12.75 4.8C15.1875 4.8 17.625 6.396 17.625 9.6V16.8Z' />
        </SvgIcon>
    );
});
